<div
  class="ui attached segment"
  appMargin
  marginT="5"
  style="border: 1px solid #dcdcdc; border-radius: 4px"
  appPadding
  paddingX="40px"
>
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
    <div fxFlex="15">{{ account?.transactionRef }}</div>
    <div fxFlex="12">
      {{ account?.remark }}
    </div>
    <div fxFlex="11">
      {{ currencyCode }} {{ account.creditAmount | number: "1.2-2" }}
    </div>
    <div fxFlex="11">
      {{ currencyCode }} {{ account.debitAmount | number: "1.2-2" }}
    </div>
    <div fxFlex="12">
      <span
        class="ui grey circular label"
        [ngClass]="{
          green: account?.status === 'OKAY',
          red: account?.status !== 'OKAY'
        }"
        >{{ account?.status == "OKAY" ? "SUCCESSFUL" : "FAILED" }}</span
      >
    </div>
    <div fxFlex="27">
      {{ account?.dateCreated | date: "medium" }}
    </div>
    <div fxFlex="12" class="text-right">
      <div class="ui basic primary dropdown" suiDropdown>
        <esl-button
          buttonType="primary"
          buttonSize="small"
          buttonState="outline"
          buttonActionState="default"
          [hasLine]="true"
          [hasSuffixIcon]="true"
          [buttonMenu]="'dropdownMenu'"
          [hasDropdown]="true"
          [isClickable]="true"
        ></esl-button>
        <div
          class="left menu actions-dropdown"
          style="right: 16px !important; top: 36px"
          suiDropdownMenu
        >
          <div class="item" (click)="viewDetails()">
            View Transaction Details
          </div>
          <ng-container *ngIf="account.transactionDocumentPath">
            <a
              [href]="sanitizedUrl"
              target="_blank"
              class="item"
              *ngIf="
                account?.transactionDocumentPath &&
                account?.transactionTag == 'E_WALLET_DEPOSIT'
              "
            >
              <div (click)="viewDepositSlip()">View Deposit Slip</div>
            </a>
            <a
              [href]="sanitizedUrl"
              target="_blank"
              class="item"
              *ngIf="
                account?.transactionDocumentPath &&
                account?.transactionTag == 'E_WALLET_WITHDRAWAL'
              "
            >
              <div (click)="viewDepositSlip()">View Withdrawal Slip</div>
            </a>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
